import axios from 'axios';
import config from '../../config';
import Base from './Base';

export default class API extends Base {

    async get(method, params) {
        const headers = { ...this.headers, 'Authorization': 'Bearer ' + this.state.token };
        const query = config.slow + new URLSearchParams(params).toString();
        const promiseResp = fetch(config.apiUrl + '/' + method + '?' + query, {
            method: 'GET',
            headers,
        });
        return this.wrapResponse(promiseResp);
    }

    async post(method, params) {
        const headers = { ...this.headers, 'Authorization': 'Bearer ' + this.state.token };
        const query = config.slow ? '?' + config.slow.slice(0, -1) : '';
        const promiseResp = fetch(config.apiUrl + '/' + method + query, {
            method: 'POST',
            headers,
            body: JSON.stringify({ ...params }),
        });
        return this.wrapResponse(promiseResp);
    }

    async publicGet(method, params) {
        const query = config.slow + new URLSearchParams(params).toString();
        const promiseResp = fetch(config.apiUrl + '/' + method + '?' + query, {
            method: 'GET',
            headers: this.headers,
        });
        return this.wrapResponse(promiseResp);
    }

    async publicPost(method, params) {
        const query = config.slow ? '?' + config.slow.slice(0, -1) : '';
        const promiseResp = fetch(config.apiUrl + '/' + method + query, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify({ ...params }),
        });
        return this.wrapResponse(promiseResp);
    }

    async postFile(method, body) {
        return axios.post(config.apiUrl + '/' + method, body, {
            headers: { ...this.headers, 'Authorization': 'Bearer ' + this.state.token, 'Content-Type': 'multipart/form-data' },
        });
    }

    async jwtLogin(login, password) {
        const url = config.apiUrl + '/api/v1/auth/jwt/getToken';
        let resp;
        try {
            resp = await fetch(url, {
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify({ login, password }),
            });
        } catch (err) {
            this.errNotifier({ title: 'Network error', description: err.toString() });
            return { success: false, data: null, errors: [] };
        }

        const json = await resp.json();

        if (json.token) {
            return { success: true, data: json };
        }

        if (!json.success) {
            json.errors?.forEach(err => this.errNotifier({ title: err.title, description: err.description }));
        }
        return json;
    }

}
